import React from 'react';
import { Brain } from 'lucide-react';

interface LoadingProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

export const LoadingSpinner = ({ className = '', size = 'md' }: LoadingProps) => {
    const sizeClasses = {
        sm: 'w-5 h-5 border-2',
        md: 'w-8 h-8 border-[3px]',
        lg: 'w-12 h-12 border-4'
    }[size];

    return (
        <div className={`animate-spin rounded-full border-indigo-600 border-t-transparent ${sizeClasses} ${className}`} />
    );
};

interface LoadingScreenProps {
    message?: string;
}

export const LoadingScreen = ({ message = 'Carregando...' }: LoadingScreenProps) => {
    return (
        <div className="flex flex-col items-center justify-center h-full min-h-[50vh] w-full bg-slate-50 animate-in fade-in duration-500">
            <div className="relative mb-6">
                <div className="absolute inset-0 bg-indigo-500 blur-xl opacity-20 rounded-full animate-pulse"></div>
                <div className="relative bg-white p-4 rounded-2xl shadow-lg ring-1 ring-slate-100">
                    <Brain size={40} className="text-indigo-600 animate-pulse" />
                </div>
                <div className="absolute -bottom-1 -right-1">
                    <LoadingSpinner size="sm" className="bg-white rounded-full shadow-sm" />
                </div>
            </div>
            <h3 className="text-lg font-semibold text-slate-800 tracking-tight">Persona<span className="text-indigo-600">Lab</span></h3>
            <p className="text-sm text-slate-500 mt-2 animate-pulse">{message}</p>
        </div>
    );
};

export const LoadingOverlay = () => {
    return (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center rounded-lg animate-in fade-in">
            <LoadingSpinner />
        </div>
    );
};
